const $mediaList = document.getElementById('press__media-list');
const $releasesList = document.getElementById('press__releases-list');
const $moreMediaButton = document.getElementById('js-press-more-media');
const $moreReleasesButton = document.getElementById('js-press-more-releases');
let moreMedia;
if (document.getElementById('pressdata-media')) {
  moreMedia = JSON.parse(document.getElementById('pressdata-media').textContent);
}
let moreReleases;
if (document.getElementById('pressdata-media')) {
  moreReleases = JSON.parse(document.getElementById('pressdata-releases').textContent);
}

function showMoreMedia() {
  const toShow = moreMedia.splice(0, 5);
  let html = ``;
  toShow.forEach((item) => {
    html += `<li>
      <time class="press__media-date">${item.date}</time>
      <span class="press__media-publisher">${item.publisher}</span>
      <a href="${item.url}" rel="noopener noreferrer" target="_blank">
        <span class="press__media-title">${item.title}</span>
        <svg width="16" height="16" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M9 3a1 1 0 0 1 0 2H3c-.551 0-1 .449-1 1v11c0 .552.449 1 1 1h11a1 1 0 0 0 1-1v-6a1 1 0 1 1 2 0v6c0 1.654-1.346 3-3 3H3c-1.654 0-3-1.346-3-3V6c0-1.654 1.346-3 3-3h6Zm10-3a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V3.414l-9.293 9.293a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L16.586 2H13a1 1 0 1 1 0-2Z" fill="navy"/></g></svg>
      </a>
    </li>`;
  });
  $mediaList.insertAdjacentHTML('beforeend', html);

  if (moreMedia.length < 1) {
    $moreMediaButton.style.display = 'none';
  }
}

function showMoreReleases() {
  const toShow = moreReleases.splice(0, 3);
  let html = ``;
  toShow.forEach((item) => {
    html += `<div class="press__releases-item">
      <div class="press__releases-item-image" aria-hidden="true">
        <img ${item.imageIsDefault === 'true' ? 'class="press__releases-item-image--default"' : null} src="${
      item.image
    }" alt="">
      </div>
      <h3><a href="${item.url}">${item.title}</a></h3>
      <time class="press__date">${item.date}</time>
    </div>`;
  });
  $releasesList.insertAdjacentHTML('beforeend', html);

  if (moreReleases.length < 1) {
    $moreReleasesButton.style.display = 'none';
  }
}

function init() {
  if ($moreMediaButton) {
    $moreMediaButton.addEventListener('click', showMoreMedia);
  }

  if ($moreReleasesButton) {
    $moreReleasesButton.addEventListener('click', showMoreReleases);
  }
}

export { init };
